// @ts-nocheck
import { AccordionStyle } from "@insite/mobius/Accordion";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown, { ChevronDownOffset } from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import Minus, { MinusOffset } from "@store/Library/Components/Toolkit/Icons/Minus";
import Plus, { PlusOffset } from "@store/Library/Components/Toolkit/Icons/Plus";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";

const iconSize = "1.2em";
/* Store Custom Code - End */

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        background-color: ${getColor("common.background") /* Store Custom Code */};
        border: 1px solid ${getColor("common.borderDark") /* Store Custom Code */};
        color: ${getColor("text.main")};
        transition: ${transitionHoverStyles("background-color", "color") /* Store Custom Code */};
        /* Store Custom Code - Start */
        border-left: none;
        border-right: none;
        /* Store Custom Code - End */

        ${({ theme }) => css`
            ${breakpointValues(pxToRemArray([16, 24]), ["padding-top", "padding-bottom"]) /* Store Custom Code */}
            ${breakpointValues(pxToRemArray([6, 18]), ["padding-right"]) /* Store Custom Code */}
            font-family: ${theme.design.typography.fontFamily.title /* Store Custom Code */};
            font-size: ${theme.design.typography.size.larger /* Store Custom Code */};
            font-weight: ${theme.design.typography.weight.base /* Store Custom Code */};
            line-height: ${theme.design.typography.lineHeight.small};
            /* Store Custom Code - Start */
            padding-left: 0;
            /* Store Custom Code - End */
        `}

        &[aria-expanded="true"] {
            background-color: ${getColor("common.background")};
            border-color: ${getColor("common.borderDark") /* Store Custom Code */};
            border-bottom-color: transparent; /* Store Custom Code */
        }

        &:hover {
            color: ${getColor("primary.main")};
        }

        /* Store Removed - breakpoint("lg") */
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

const accordion: Styleguide["accordion"] = {
    sectionDefaultProps: {
        headerProps: {
            css: css`
                ${_headerButtonStyles()}

                ${AccordionSectionPanel} + && {
                    ${_headerButtonStyles()}
                    ${({ theme }) => css`
                        ${breakpointValues(theme.design.accordion.spacing, "margin-top")}
                    `}
                }

                ${AccordionStyle} + ${AccordionStyle} && {
                    &:first-of-type {
                        ${({ theme }) => css`
                            ${breakpointValues(theme.design.accordion.spacing, "margin-top")}
                        `}
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                ${({ theme }) => css`
                    ${breakpointValues(theme.design.accordion.padding.horizontal, "padding")}
                    ${
                        /* Store Custom Code - Start */
                        breakpointValues(theme.design.accordion.padding.vertical, [
                            "padding-top",
                            "padding-bottom",
                            "margin-bottom",
                        ])
                        /* Store Custom Code - End */
                    }
                `}
                background-color: ${getColor("common.accent") /* Store Custom Code */};
                border: none; /* Store Custom Code */
                border-top: none;
            `,
        },
        // Store Removed - toggleIconProps
        /* Store Custom Code - Start */
        expandIconProps: {
            src: Plus,
            color: "inherit",
            css: iconScalableStyles(iconSize, PlusOffset),
        },
        collapseIconProps: {
            src: Minus,
            color: "inherit",
            css: iconScalableStyles(iconSize, MinusOffset),
        },
        /* Store Custom Code - End */
        titleTypographyProps: null as any,
        toggleTransition: {
            transitionCss: css`
                transition: none;
                bottom: auto;
                /* Store Custom Code - Start */
                position: relative;
                display: flex;
                /* Store Custom Code - End */
            `,
            timeout: { enter: 0, exit: 0 },
            /* Store Custom Code - Start */
            positionerCss: css`
                padding: 0;
                width: auto;
                height: auto;
                max-width: none;
                max-height: none;
                margin-left: ${pxToRem(16)};
            `,
            /* Store Custom Code - End */
        },
    },
};

export default accordion;
